<template>
  <el-dialog title="图层设置" :visible.sync="dialogVisible" width="40%" append-to-body :close-on-click-modal="false" >
    <sd-layer-config ref="layerConfig" :min="min" :max="max" :show-all="showAll_"></sd-layer-config>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="showAll_ = !showAll_">{{showAll_?'隐藏部分':'显示全部'}}</el-button>
        <el-button @click="close">关闭</el-button>
        <el-button type="primary" @click="confirm">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import SdLayerConfig from './SdLayerConfig.vue';
export default {
  name: 'SdLayerConfigDialog',
  components:{ SdLayerConfig},
  props: {
    min:{
      type:Number,
      default:0
    },
    max:{
      type:Number,
      default:20
    }
  },
  data() {
    return {
      dialogVisible:false,
      showAll_:false
    };
  },

  mounted() {
    
  },

  methods: {
    confirm(){
      const ctr = this.$refs.layerConfig
      if (ctr) {
        const layerInfo = ctr.getData()
        this.$emit('confirm',layerInfo)
      }
      this.close()
    },
    open(layerNode){
      this.dialogVisible = true
      this.$nextTick(()=>{
        const ctr = this.$refs.layerConfig
        ctr && ctr.reset(layerNode)
      })
    },
    close(){
      this.dialogVisible = false
    }
  },
};
</script>